import IndividualTable from "../../../IndividualTable";
import { sampleData2 } from "../../sampleData";

const Distance70 = () => {
  return <IndividualTable matchType={"PRE"} gender="F" event="70" subTitle="Puta" data={sampleData2} topRankCount="16" />;
};
export default Distance70;
